(() => {
  const strings = document.getElementById('dheart-market-strings');
  const label = strings && JSON.parse(strings.textContent).sort_reviews;
  if (!label) return;

  const controls = new Map();
  const close = (picker, focus = false) => {
    picker.open = false;
    if (focus) picker.querySelector('summary').focus();
  };

  const enhance = (select) => {
    const native = select.closest('.jm-sort-filter--compact');
    const icon = native.querySelector('.jm-sort-filter__icon--sort svg');
    if (!icon || !select.options.length) return;

    const picker = document.createElement('details');
    picker.className = 'dh-review-sort';
    const trigger = document.createElement('summary');
    trigger.className = 'dh-review-sort__trigger';
    const symbol = icon.cloneNode(true);
    symbol.setAttribute('aria-hidden', 'true');
    trigger.append(symbol);
    const panel = document.createElement('div');
    panel.className = 'dh-review-sort__options';
    const buttons = Array.from(select.options, (option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = option.textContent;
      button.dataset.value = option.value;
      button.disabled = option.disabled;
      button.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        close(picker, true);
      });
      panel.append(button);
      return button;
    });
    const sync = () => {
      const title = label + ': ' + select.selectedOptions[0].textContent;
      if (trigger.getAttribute('aria-label') !== title) {
        trigger.setAttribute('aria-label', title);
        trigger.title = title;
      }
      buttons.forEach((button) => {
        const pressed = String(button.dataset.value === select.value);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        button.disabled = select.disabled || select.options[buttons.indexOf(button)].disabled;
      });
    };
    picker.append(trigger, panel);
    native.after(picker);
    native.classList.add('dh-review-sort-native');
    select.addEventListener('change', sync);
    picker.addEventListener('toggle', () => {
      if (!picker.open) return;
      controls.forEach(({ picker: other }) => {
        if (other !== picker) close(other);
      });
      panel.scrollIntoView({ block: 'nearest' });
    });
    picker.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(picker, true);
      }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      picker.open = true;
      const enabled = buttons.filter((button) => !button.disabled);
      if (!enabled.length) return;
      const index = enabled.indexOf(document.activeElement);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? enabled.length - 1
        : event.key === 'ArrowDown' ? (index + 1) % enabled.length
          : (index < 0 ? enabled.length : index + enabled.length - 1) % enabled.length;
      enabled[next].focus({ preventScroll: true });
    });
    controls.set(select, { picker, sync });
    sync();
  };

  const update = () => {
    controls.forEach(({ picker, sync }, select) => {
      if (!select.isConnected) {
        picker.remove();
        controls.delete(select);
      } else sync();
    });
    document.querySelectorAll('.jm-review-widget .jm-sort-filter--compact select').forEach((select) => {
      if (!controls.has(select)) enhance(select);
    });
  };
  document.addEventListener('click', (event) => {
    controls.forEach(({ picker }) => {
      if (picker.open && !picker.contains(event.target)) close(picker);
    });
  });
  update();
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();
